import React from "react";
import "./FooterSection.css";
import Logo from "../assets/logo.png";

function FooterSection() {
  const whatsappNumber = "447802484141";
  const facebookUrl = "https://www.facebook.com/profile.php?id=61561727786448";

  return (
    <footer className="site-footer">
      <div className="footer-container">
        
        {/* Main Footer Columns */}
        <div className="footer-grid">
          
          {/* Column 1: Brand & Bio */}
          <div className="footer-col brand-col">
            <div className="footer-logo">
              <img src={Logo} alt="Rejuvenate Aesthetics & Skincare" />
            </div>

            <p className="brand-description">
              A boutique aesthetics and skincare clinic in Milton Keynes. Natural,
              tailored results — delivered with care.
            </p>

            <div className="social-links">
              {/* WhatsApp */}
              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-circle"
                aria-label="WhatsApp"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12.031 2c-5.517 0-9.997 4.48-9.997 9.998 0 2.146.68 4.133 1.839 5.757L2 22l4.417-1.157a9.96 9.96 0 005.614 1.708c5.518 0 9.998-4.48 9.998-9.998A9.997 9.997 0 0012.031 2zm0 18.232c-1.802 0-3.504-.486-4.978-1.332l-.358-.207-2.628.688.7-2.562-.229-.365a8.214 8.214 0 01-1.282-4.456c0-4.555 3.706-8.261 8.261-8.261 4.556 0 8.262 3.706 8.262 8.261 0 4.556-3.706 8.262-8.262 8.262z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-circle"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="social-circle"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.891h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Explore */}
          <div className="footer-col">
            <h4 className="col-heading">EXPLORE</h4>
            <ul className="footer-links">
              <li><a href="#treatments">Treatments</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#offers">Offers</a></li>
              <li><a href="#results">Results</a></li>
              <li><a href="#reviews">Reviews</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="footer-col">
            <h4 className="col-heading">CONTACT</h4>
            <ul className="footer-links contact-list">
              <li><a href="tel:07802484141">07802 484141</a></li>
              <li className="address-item">
                Contact@rejuvenateaesthesticsandskincareclinic.co.uk
              </li>
              <li className="address-item">
                26 Victoria Drive Glebe Farm MK17 8XU
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar / Copyright */}
        <div className="footer-bottom">
          <p>© 2026 Rejuvenate Aesthetics & Skincare Clinic MK. All rights reserved.</p>
           <p>Created with a little magic by Vanshika ✧</p>
        </div>

      </div>
    </footer>
  );
}

export default FooterSection;